/**
 * All breakpoints and their min-width
 */
 const breakpoints = {
   xs: 0,
   sm: 576,
   md: 768,
   lg: 992,
   xl: 1200,
   xxl: 1400,
};

/**
 * Check if the current reakpoint is greater or equals a breakpoint
 *
 * @param {string} breakpoint
 * @returns boolean
 */
 function breakpointGreaterThanEquals(breakpoint) {
   return window.innerWidth >= breakpoints[breakpoint];
}

const easings = {
   EASE: 'cubic-bezier(0.87, 0, 0.13, 1)',
   EASE_IN: 'cubic-bezier(0.7, 0, 0.84, 0)',
   EASE_OUT: 'cubic-bezier(0.16, 1, 0.3, 1)',
};

export {
   breakpoints,
   breakpointGreaterThanEquals,
   easings
}
